import { render, staticRenderFns } from "./DealNew.vue?vue&type=template&id=7e846946&scoped=true&"
import script from "./DealNew.vue?vue&type=script&lang=js&"
export * from "./DealNew.vue?vue&type=script&lang=js&"
import style0 from "./DealNew.vue?vue&type=style&index=0&id=7e846946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e846946",
  null
  
)

export default component.exports